import { ImageIcon } from "lucide-react";

type SelectedRecordProps = {
  image: string | undefined | null;
  title: string;
};

const SelectedRecord = ({ image, title }: SelectedRecordProps) => {
  return (
    <div className="flex items-center gap-2 min-w-0 max-w-full overflow-hidden">
      {image ? (
        <img
          src={image}
          alt=""
          className="size-8 aspect-square object-contain rounded flex-shrink-0"
        />
      ) : (
        <div className="size-8 aspect-square flex items-center justify-center bg-gray-100 rounded flex-shrink-0">
          <ImageIcon className="size-4 text-gray-400" />
        </div>
      )}
      <span 
        className="font-[Raleway] font-medium text-xs truncate flex-1 min-w-0" 
        title={title}
      >
        {title}
      </span>
    </div>
  );
};

export default SelectedRecord;
